import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const AdminCTA = () => {
  const navigate = useNavigate();

  const pricingTiers = [
    {
      name: "Creator Management",
      price: "R3,499",
      description: "Manage creator applications, portfolios & bookings",
    },
    {
      name: "Venue Oversight",
      price: "R5,299",
      description: "Oversee venue partnerships, events & compliance",
    },
    {
      name: "Platform Control",
      price: "Custom",
      description: "Full platform access with enterprise features",
    },
  ];

  return (
    <section className="py-20 bg-black">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-4">
            Agency Pricing
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            Professional tools for managing Africa's entertainment ecosystem
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto mb-12">
          {pricingTiers.map((tier) => (
            <div
              key={tier.name}
              className="bg-white/5 border border-white/10 rounded-2xl p-6 text-center"
            >
              <h3 className="text-xl font-semibold text-white mb-2">{tier.name}</h3>
              <p className="text-3xl font-bold text-white mb-2">
                {tier.price}
                {tier.price !== "Custom" && <span className="text-sm text-gray-400">/month</span>}
              </p>
              <p className="text-gray-400 text-sm">{tier.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Button
            onClick={() => navigate("/agency-pricing")}
            className="bg-white text-black hover:bg-gray-200 px-8 py-3 rounded-xl text-lg font-semibold"
          >
            Request Consultation
          </Button>
        </div>
      </div>
    </section>
  );
};

export default AdminCTA;
